;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Layout     = APP.module('Layout');
	var Collection = APP.module('Collection');

	Layout.LeaguesManage = Marionette.LayoutView.extend({
		template: JST.TippingLeaguesManage,
		regions: {
			info:  "#info-region",
			timer: "#timer-region",
			tabs:  "#tabs-region"
		}
	});

}(window, APP, Backbone, Marionette, $, _));